/* @refresh reload */
import { render } from 'solid-js/web';
import App from './app';
import { registerAwarenessOverlays } from '@overlays/register';
import './styles/global.css';

registerAwarenessOverlays();

// Drop legacy share-link hashes (#f=…) from earlier builds
if (typeof window !== 'undefined' && window.location.hash.startsWith('#f=')) {
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}`,
  );
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root');
}

render(() => <App />, root);
